import Vuex from "vuex"
import axios from 'axios'

const store = Vuex.createStore({
    state(){
        return {
            cards: [],
            loading: false,
            filter: "",
            filter_type: "",
            filter_categorie: "",
            sort_ascending: false,
            activity_id: 0,
        }
    },
    getters:{
        Activity(state){
            return state.cards.find(card => card.id == state.activity_id);
        },
        NumCards(state, getters){
            return getters.CardsList.length;
        },
        CardsList(state){
            let T = [];
            state.cards.forEach(element => {
               if(  element.responsabil.toLowerCase().indexOf(state.filter_type.toLowerCase()) !== -1 
                    &&
                    element.categorie_activitate.toLowerCase().indexOf(state.filter_categorie.toLowerCase()) !== -1
                )
                T.push(element);
            });
            return T.sort((a,b)=>{
              if(state.sort_ascending)
              {
                if(a.date < b.date)
                  return -1;
                else
                  if(a.date > b.date)
                    return 1;
                  else
                    return 0;
              }
              if(a.date < b.date)
                return 1;
              else
                if(a.date > b.date)
                  return -1;
                else
                  return 0;
            });
          }
    },
    mutations:{
        updateCards(state, newCards)
        {
            state.cards = newCards;
        },
        updateLoading(state, newVal)
        {
            state.loading = newVal;
        },
        updateFilter(state, newVal)
        {
            state.filter = newVal;
        },
        updateFilterType(state, newVal)
        {
            state.filter_type = newVal;
        },
        updateFilterCategorie(state, newVal)
        {
            state.filter_categorie = newVal;
        },
        updateSortAscending(state, newVal)
        {
            state.sort_ascending = newVal;
        },
        updateActivityId(state, newVal)
        {
            state.activity_id = newVal;
        }
    },
    actions:{
        async loadCards(context){
            try{
                console.log("Loading activities");
                context.commit('updateLoading', true);
                let response = await axios.get("https://docs.google.com/spreadsheets/d/e/2PACX-1vSho_5eg9G50nVJwToeqGXyKk_KZP11WsSY0lYaLHjb0H67PtPfI1HUo_laMQa0vCTj-GAy6OKhA3eU/pub?gid=1415740207&single=true&output=tsv")
                context.commit('updateLoading', false);
                let T = [];
                response.data.split('\n').forEach((element , index) => {
                    if(index > 0)
                    {
                        let V = element.split('\t');
                        //console.log(V)
                        let obj = {
                            id: index
                        }
                        if(V[1] == 'ciclul primar')
                        {
                            obj.ciclu = 'primar'
                            obj.responsabil = V[2]
                            obj.clasa = V[3]
                        }
                        if(V[1] == 'ciclul gimnazial')
                        {
                            obj.ciclu = 'gimnazial'
                            obj.responsabil = V[4]
                            obj.clasa = V[5]
                        }
                        if(V[1] == 'ciclul liceal')
                        {
                            obj.ciclu = 'liceal'
                            obj.responsabil = V[6]
                            obj.clasa = V[7]
                        }
                        obj.categorie_activitate = V[8]
                        if(obj.categorie_activitate == 'Evenimente (zile internaționale, naționale, mondiale etc)')
                        {
                            obj.eveniment = V[9]
                            obj.data = new Date(V[10].split('.').reverse().join('-'))
                            obj.modul = V[11]
                            obj.nr_participanti_clasa = parseInt(V[12])
                            obj.nr_participanti_externi = parseInt(V[13])
                            obj.descriere = V[14]
                            obj.imagini = V[15]?V[15].split(','):[]
                            obj.links = V[16]?V[16].split(','):[]
                        }
                        if(obj.categorie_activitate == 'Școala încrederii')
                        {
                            obj.eveniment = V[17]
                            obj.data = new Date(V[18].split('.').reverse().join('-'))
                            obj.modul = ''
                            obj.nr_participanti_clasa = parseInt(V[19])
                            obj.nr_participanti_externi = 0
                            obj.descriere = V[20]
                            obj.imagini = V[21]?V[21].split(','):[]
                            obj.links = V[22]?V[22].split(','):[]
                        }
                        if(obj.categorie_activitate == 'Alte activități')
                        {
                            obj.eveniment = V[23]
                            obj.data = new Date(V[24].split('.').reverse().join('-'))
                            obj.modul = V[25]
                            obj.nr_participanti_clasa = parseInt(V[26])
                            obj.nr_participanti_externi = parseInt(V[27])
                            obj.descriere = V[28]
                            obj.imagini = V[29]?V[29].split(','):[]
                            obj.links = V[30]?V[30].split(','):[]
                        }
                        T.push(obj)
                    }
                });
                context.commit('updateCards', T);
                console.log(T)
                console.log("Finished loading activities");
            }catch(Err){
                console.log(Err.message)
            }
        }
    }
})

export default store